module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.goPage(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    staticClass: "inpSm",
    attrs: {
      "min": "1",
      "type": "number"
    },
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.goPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v("\n    " + _vm._s(_vm.getTranslation('lbl_items_per_page')) + "\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perpage),
      expression: "perpage"
    }],
    staticClass: "inpSm",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.perpage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.perpage = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45edc80c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Banet/components/BanetPagination.vue
// module id = 674
// module chunks = 0